import React from 'react';
import uuidv4 from 'uuid';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Tooltip, Fade } from '@material-ui/core';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 350,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class EditTipoMovRedem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.tipoMovRedem.id ? this.props.tipoMovRedem.id : uuidv4(),
            descr: this.props.tipoMovRedem.descr ? this.props.tipoMovRedem.descr : '',
            descrWeb: this.props.tipoMovRedem.descrWeb ? this.props.tipoMovRedem.descrWeb : '',
            b_signo: this.props.tipoMovRedem.signo ? (this.props.tipoMovRedem.signo > 0) : false,
            activo: this.props.tipoMovRedem.activo ? this.props.tipoMovRedem.activo : true,
        };

    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };

    handleBooleanChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.checked });
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'descr'}
                            label={'Descripción'}
                            placeholder={'Descripción'}
                            margin="normal"
                            autoFocus
                            value={this.state.descr}
                            onChange={(event) => this.handleValueChange(event, 'descr')}
                        />
                    </FormControl>
                </div>
                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'descrWeb'}
                            label={'Descripción Web'}
                            placeholder={'Descripción Web'}
                            margin="normal"
                            value={this.state.descrWeb}
                            onChange={(event) => this.handleValueChange(event, 'descrWeb')}
                        />
                    </FormControl>
                </div>
                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <Tooltip title="Indica si es un movimiento de carga" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.b_signo ? true : false}
                                        onChange={(event) => this.handleBooleanChange(event, 'b_signo')}
                                        value='b_signo'
                                    />
                                }
                                label="Movimiento de Carga"
                            />
                        </Tooltip>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.activo ? true : false}
                                    onChange={(event) => this.handleBooleanChange(event, 'activo')}
                                    value='activo'
                                />
                            }
                            label="Activo"
                        />
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const tipoMovRedem = {
                            id: this.state.id,
                            descr: this.state.descr,
                            descrWeb: this.state.descrWeb,
                            signo: (this.state.b_signo ? 1 : -1),
                            activo: this.state.activo,
                        }

                        if (this.props.checkTipoMovRedem(tipoMovRedem)) {
                            this.props.okHandler(tipoMovRedem);
                            this.props.hideDialog();
                        }
                    }
                    }>Guardar</Button>
                </div>
            </div>
        );
    };

};

EditTipoMovRedem.propTypes = {
    tipoMovRedem: PropTypes.object.isRequired,
    checkTipoMovRedem: PropTypes.func.isRequired,
    okHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditTipoMovRedem);